/* eslint-disable import/prefer-default-export */
// PRD-2719: the "should this session be handed off to the enhanced portal?" decision, kept out
// of app.tsx so it can be unit-tested on its own — AppContent is not exported and rendering App
// pulls in the whole route tree, Auth0 and the analytics scripts.
//
// Every user type hands off on its own per-user flag. Talent ("employee") was carved out when
// this gate was extracted, which left PRD-2124 half-delivered: the backend already computes the
// talent's flag at login and returns it on /employee/:id, and the admin UI already exposes a
// toggle to set it — but nothing read it, so flipping the toggle did nothing.
//
// The flags sit at different depths because app.tsx fetches a different endpoint per user type:
// /customer/:id/info and /employee/:id both return the record itself, so the flag is top-level,
// while /user/:id/summary returns an envelope ({ user, totalPayroll, totalEmployees, ... }), so
// the edge flag is nested under `.user`.

export type PortalUserType = "edge" | "customer" | "employee";

interface EdgeUserSummary {
  enableEnhancedPortalExperience?: boolean;
}

export interface EnhancedPortalUserInfo {
  enableEnhancedPortalExperience?: boolean;
  user?: EdgeUserSummary | null;
}

export const shouldHandOffToEnhancedPortal = (
  userType: PortalUserType | null | undefined,
  userAdditionalInfo: EnhancedPortalUserInfo | null | undefined
): boolean => {
  if (userType === "customer" || userType === "employee") {
    return !!userAdditionalInfo?.enableEnhancedPortalExperience;
  }
  if (userType === "edge") return !!userAdditionalInfo?.user?.enableEnhancedPortalExperience;
  return false;
};
